import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";
import { changePassword } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function ChangePassword() {
  const { user, refreshMe, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("Le password non coincidono"); return; }
    if (next.length < 8 || !/\d/.test(next)) {
      toast.error("Min 8 caratteri + 1 numero");
      return;
    }
    setLoading(true);
    try {
      await changePassword(current, next);
      toast.success("Password aggiornata. Effettua di nuovo il login.");
      // change-password ha revocato tutti i token → logout forzato
      await logout();
      nav("/login", { replace: true });
    } catch (ex) {
      toast.error(ex.response?.data?.detail || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1B5E20]/5 via-white to-[#F57C00]/5 p-4" data-testid="change-password-page">
      <Card className="w-full max-w-md p-6 sm:p-8 shadow-xl">
        <div className="flex flex-col items-center mb-6">
          <div className="h-14 w-14 rounded-2xl bg-[#F57C00] flex items-center justify-center text-white mb-3">
            <KeyRound size={26} />
          </div>
          <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
            Cambio password obbligatorio
          </h1>
          <p className="text-sm text-slate-500 mt-1 text-center">
            {user?.ultimoAccesso ? "L'amministratore ha forzato un reset" : "Primo accesso"}: imposta una nuova password prima di proseguire.
          </p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider">Password attuale</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="h-12" required data-testid="current-pwd-input" autoFocus />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Nuova password</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="h-12" required data-testid="new-pwd-input" />
            <p className="text-[11px] text-slate-400 mt-1">Min 8 caratteri, almeno 1 numero</p>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Conferma nuova password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12" required data-testid="confirm-pwd-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 bg-[#1B5E20] hover:bg-[#144818] text-white font-semibold min-h-[44px]" data-testid="change-password-submit">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Cambia password"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
